import * as ActionTypes from './types.action';

export const applyForCredit = ({
  companiesHouseNumber,
  directorEmail,
  requestedMonthlyCreditLimit,
}) => ({
  type: ActionTypes.APPLY_FOR_CREDIT_REQUESTED,
  data: {companiesHouseNumber, directorEmail, requestedMonthlyCreditLimit},
});

export const resetCreditApplication = () => ({
  type: ActionTypes.RESET_CREDIT_APPLICATION,
});

// Live lookup of a Companies House number so the user can confirm the company
// before applying. The saga debounces these requests.
export const lookupCompany = companiesHouseNumber => ({
  type: ActionTypes.LOOKUP_COMPANY_REQUESTED,
  companiesHouseNumber,
});

export const resetCompanyLookup = () => ({
  type: ActionTypes.RESET_COMPANY_LOOKUP,
});
